import { useTheme as rawUseTheme } from './useTheme';
import { css as rawCss } from './css';
import { styledWithTheme as rawStyledWithTheme } from './styledWithTheme';
import { withTheme as rawWithTheme } from './withTheme';
const css = rawCss;
const useTheme = rawUseTheme;
const withTheme = rawWithTheme;
const styledWithTheme = rawStyledWithTheme;
export { css, useTheme, withTheme };
export default styledWithTheme;
/** Safely reference a specialty color token to pass to a token property.
 *
 * Use like `<Flex backgroundColor={specialtyColor('breeze-fill-primary-default')}/>`
 */
export function specialtyColor(token) {
  return token;
}